import { Checkbox } from "@/components/ui/Field";
import { NativeSelect } from "@/components/ui/NativeSelect";
import type { HeroCustomFieldProperty } from "@/lib/projects";
import {
  heroFieldOptions,
  normalizeHeroFieldType,
} from "@/components/hero/heroCustomFieldUtils";

export function HeroCustomFieldInput({
  property,
  inputId,
  value,
  disabled,
  onChange,
}: {
  property: HeroCustomFieldProperty;
  inputId: string;
  value: string | boolean;
  disabled?: boolean;
  onChange: (value: string | boolean) => void;
}) {
  const type = normalizeHeroFieldType(property.type);
  const label = property.label || "Eigenes Feld";
  const hint = property.hint;
  const options = heroFieldOptions(property);

  if (type === "checkbox") {
    return (
      <Checkbox
        id={inputId}
        label={label}
        description={hint || undefined}
        disabled={disabled}
        checked={Boolean(value)}
        onChange={(e) => onChange(e.target.checked)}
      />
    );
  }

  if ((type === "selection" || type === "select") && options.length > 0) {
    return (
      <div className="space-y-1">
        <label className="eh-label" htmlFor={inputId}>
          {label}
        </label>
        <NativeSelect
          id={inputId}
          selectSize="sm"
          disabled={disabled}
          value={String(value ?? "")}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">– bitte wählen –</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </NativeSelect>
        {hint ? <p className="text-xs text-label-secondary">{hint}</p> : null}
      </div>
    );
  }

  if (type === "textarea" || type === "longtext") {
    return (
      <div className="space-y-1">
        <label className="eh-label" htmlFor={inputId}>
          {label}
        </label>
        <textarea
          id={inputId}
          className="eh-input min-h-[4.5rem] resize-y"
          rows={3}
          disabled={disabled}
          value={String(value ?? "")}
          onChange={(e) => onChange(e.target.value)}
        />
        {hint ? <p className="text-xs text-label-secondary">{hint}</p> : null}
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <label className="eh-label" htmlFor={inputId}>
        {label}
      </label>
      <input
        id={inputId}
        type="text"
        className="eh-input"
        disabled={disabled}
        value={String(value ?? "")}
        onChange={(e) => onChange(e.target.value)}
      />
      {hint ? <p className="text-xs text-label-secondary">{hint}</p> : null}
    </div>
  );
}
